import { Alert, Button, Card, Col, Form, Input, Row, Spin } from "antd";
import Title from "antd/es/typography/Title";
import { fullWidthStyle, titleStyle } from "../constants/style";
import { useContext, useState } from "react";
import { SubmitStatus } from "../api/work-order-api";
import ApiContext from "../api/context";
import Paragraph from "antd/es/typography/Paragraph";
import Link from "antd/es/typography/Link";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function () {
  const [password, setPassword] = useState<string>("");
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>(SubmitStatus.Idle);
  const { api } = useContext(ApiContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { passwordResetRequestId } = useParams();
  
  // Read the parameters and validate them.
  const queryParams = new URLSearchParams(location.search);
  const parsedToken = queryParams.get("token")?.trim() ?? "";
  const parsedPasswordResetRequestId = Number.parseInt(passwordResetRequestId ?? "");
  const areParametersValid = !Number.isNaN(parsedPasswordResetRequestId) && parsedToken !== "";
  const [error, setError] = useState<String | undefined>(areParametersValid ? undefined : "Password reset request is invalid.");

  // Calculate conditionals.
  const isSubmitting = submitStatus === SubmitStatus.Submitting;
  const hasFailed = submitStatus === SubmitStatus.Failed || !areParametersValid;
  const hasSubmitted = submitStatus == SubmitStatus.Submitted;
  const hasValidPassword = password.trim() !== "";
  const isDone = hasFailed || hasSubmitted;
  const canSubmit = !isDone && !isSubmitting && hasValidPassword;

  return (
    <div style={{ position: "fixed", width: "100%", height: "100vh" }}>
      <Title />
      <Row justify="center">
        <Col style={{ width: "325px" }}>
          <Card>
            <Spin spinning={isSubmitting}>
              <Title style={titleStyle} level={4}>
                Password Reset
              </Title>
              <Form
                title="Password Reset"
                name="password-reset"
                layout="vertical"
                colon={false}>
                <Form.Item label="New Password">
                  <Input
                    type="password"
                    placeholder="Enter your new password"
                    disabled={isSubmitting}
                    onChange={e => setPassword(e.target.value)}
                  />
                </Form.Item>
                <Row style={fullWidthStyle} justify="space-between" align="middle">
                  <Link onClick={() => {
                    navigate("/login");
                  }}>Cancel</Link>
                  <Button
                    type="primary"
                    disabled={!canSubmit}
                    onClick={() => {
                      setSubmitStatus(SubmitStatus.Submitting);
                      api?.putPasswordReset(parsedPasswordResetRequestId, parsedToken, password).then(loginResponse => {
                        const isGood = loginResponse.good();
                        if (!isGood) {
                          switch (loginResponse.status) {
                            case 400:
                              setError("Password could not be accepted. Please try a different password.");
                              break;
                            case 401:
                              setError("Either the password reset request is invalid or you are not allowed to make this request.")
                              break;
                            default:
                              setError("There was a problem processing the password reset request.");
                              break;
                          }

                          setSubmitStatus(SubmitStatus.Failed);
                          return;
                        }

                        navigate("/login");
                      }).catch(() => {
                        setError("There was a problem processing the password reset request.");
                        setSubmitStatus(SubmitStatus.Failed);
                      });
                    }}>
                    Submit
                  </Button>
                </Row>
              </Form>
            </Spin>
          </Card>
          {
            !hasFailed ? undefined :
              <>
                <Paragraph />
                <Alert
                  type="error"
                  message={error ?? "There was a problem."} />
              </>
          }
        </Col>
      </Row>
    </div >
  );
}